import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#18d27b",
      d: "M13.999 2v1.333c0 6.419-3.582 9.334-8 9.334H4.73c.14-2.009.766-3.224 2.398-4.668.803-.71.735-1.12.34-.884-2.723 1.62-4.075 3.81-4.135 7.305l-.002.247H1.999c0-.909.077-1.734.23-2.488q-.23-1.295-.23-3.512A6.667 6.667 0 0 1 8.665 2C10 2 11.332 2.667 14 2"
    }, null, -1)
  ]))]))
}
export default { render: render }